export default "__VITE_ASSET__fa64fc96__"